import { AgencyQueryServices } from "./qrtk/agency/agency.qrtk";
import { AuthQueryServices } from "./qrtk/auth/user-auth.qrtk";
import { GeoLocalizationQueryServices } from "./qrtk/geo-localization/geo-localization.qrtk";
import { MortgageQueryServices } from "./qrtk/mortgage/mortgage.qrtk";
import { OwnersQueryServices } from "./qrtk/owners/owners.qrtk";
import { ReportsQueryServices } from "./qrtk/reports/reports.qrtx";
import { ReviewsQueryServices } from "./qrtk/reviews/reviews.qrtk";
import { UsersQueryServices } from "./qrtk/users/users.qrtk";
import { SectorProposalsQueryServices } from "./qrtk/sector-proposals/sector-proposals.qrtk";
interface IStoreQRTK {
  reducer: {};
  middleware: any[];
}
export const storeQRTK: IStoreQRTK = {
  reducer: {
    [AuthQueryServices.reducerPath]: AuthQueryServices.reducer,
    [AgencyQueryServices.reducerPath]: AgencyQueryServices.reducer,
    [GeoLocalizationQueryServices.reducerPath]:
      GeoLocalizationQueryServices.reducer,
    [MortgageQueryServices.reducerPath]: MortgageQueryServices.reducer,
    [OwnersQueryServices.reducerPath]: OwnersQueryServices.reducer,
    [ReviewsQueryServices.reducerPath]: ReviewsQueryServices.reducer,
    [UsersQueryServices.reducerPath]: UsersQueryServices.reducer,
    [ReportsQueryServices.reducerPath]: ReportsQueryServices.reducer,
    [SectorProposalsQueryServices.reducerPath]:
      SectorProposalsQueryServices.reducer
  },
  middleware: [
    AuthQueryServices.middleware,
    AgencyQueryServices.middleware,
    GeoLocalizationQueryServices.middleware,
    MortgageQueryServices.middleware,
    OwnersQueryServices.middleware,
    ReviewsQueryServices.middleware,
    UsersQueryServices.middleware,
    ReportsQueryServices.middleware,
    SectorProposalsQueryServices.middleware
  ]
};
